import * as React from 'react'
import { MenuItem, Menu, List, ListItem, ListItemText } from '@material-ui/core'

export default function SelectTarea ({ tarea, tareas, changeForm }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [selectedTarea, setSelectedTarea] = React.useState(tarea)
  const open = Boolean(anchorEl)
  const [textMenu, setTextMenu] = React.useState(tarea ? '' : 'Seleccione una tarea')

  const handleClickListItem = (e) => {
    setAnchorEl(e.currentTarget)
  }

  if (selectedTarea && !tarea) {
    setSelectedTarea(null)
    setTextMenu('Seleccione una tarea')
  }

  const handleMenuItemClick = (e, t, tarea) => {
    setSelectedTarea(tarea)
    setAnchorEl(null)
    setTextMenu('')
    changeForm(t)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  if (!(tareas instanceof Array) || (tareas && (tareas.length < 1))) { return null }

  return (
    <div style={{ width: '60%' }}>
      {tareas && <>
        <div style={{ backgroundColor: 'rgb(228 228 228)' }} className={'paper-calificaciones'} >
          <List
            style={{ margin: '0', padding: '0' }}
            component='nav'
            aria-label='Device settings'
          >
            <ListItem
              style={{ padding: '0', width: '100%' }}
              button
              aria-label='tarea seleccionada'
              onClick={handleClickListItem}
            >
              <ListItemText
                style={{ margin: '5px 15px' }}
                secondary={textMenu}
                primary={[selectedTarea]}
              />
            </ListItem>
            <Menu
              id='lock-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              {tareas.map((tarea) => (
                <MenuItem
                  key={tarea.nombreCorto}
                  selected={tarea.nombre === selectedTarea}
                  onClick={(e) => handleMenuItemClick(e, tarea.nombreCorto, tarea.nombre)}
                >
                  {tarea.nombre}
                </MenuItem>
              ))
              }
            </Menu>
          </List>
        </div>
      </>}
    </div>
  )
}
